import DiscountItem from './DiscountItem'

export * from './DiscountItem'

export default DiscountItem
